import React, { useContext } from "react";
import { ProcessContext } from "../../../../contexts/ProcessContext";
import { VideoIdErrorMessage } from "./components/VideoIdErrorMessage";
import { VideoIdSuccessMessage } from "./components/VideoIdSuccessMessage";
import { Box, CircularProgress, useTheme } from "@material-ui/core";
import { modules } from "../..";

export default function VideoIdResult() {
  const {
    state: { videoIdProcessPassed },
    dispatch,
  } = useContext(ProcessContext);

  const { palette } = useTheme();

  const repeatVideoId = () => {
    dispatch({
      type: "UPDATE_PROCESS_CONTEXT",
      payload: {
        videoIdProcessPassed: undefined,
        flowItem: modules.VIDEO_ID,
        flowItemIsKO: false,
      },
    });
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: false },
    });
  };

  return (
    <>
      {videoIdProcessPassed === undefined && (
        <Box
          height={"100%"}
          display={"flex"}
          flexGrow={1}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CircularProgress
            className={"transition-all"}
            size={100}
            thickness={1.5}
            style={{
              margin: "-20px 0 0 0",
              color: palette.secondary.main,
            }}
          />
        </Box>
      )}
      {videoIdProcessPassed === true && <VideoIdSuccessMessage />}
      {videoIdProcessPassed === false && (
        <VideoIdErrorMessage repeatVideoId={repeatVideoId} />
      )}
    </>
  );
}
